var React = require('react');

function SortDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 12.174V1a1 1 0 1 1 2 0v11.179l1.513-1.483a1.027 1.027 0 0 1 1.438 0 .988.988 0 0 1 0 1.415l-3.948 3.887-3.954-3.89a.988.988 0 0 1 0-1.416 1.027 1.027 0 0 1 1.438 0L7 12.174z"}));
}

SortDown.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = SortDown;

SortDown.default = SortDown;
